import type { Country } from "@sveabank/cc-common";
import type { ContactFormValues } from "../../types/contact-information";
import type {
	ApplicantContactInformationStep,
	OrganizationContactInformationStep,
	Step,
} from "../../types/step";
import { getApplicationLanguage } from "../../utils/storage";

export const getInitialValuesFromStep = (steps?: Step[]): Partial<ContactFormValues> => {
	if (!steps) {
		return {};
	}
	const applicantValues = steps?.find(
		(s) => s.name === "ApplicantContactInformationStep" && s.status === "Completed",
	) as ApplicantContactInformationStep;
	const orgValues = steps?.find(
		(s) => s.name === "OrganizationContactInformationStep" && s.status === "Completed",
	) as OrganizationContactInformationStep;

	const initialValues = {
		companyCountryCode: orgValues?.state?.phone?.countryCode,
		companyPhone: orgValues?.state?.phone?.number,
		companyEmail: orgValues?.state?.email,
		countryCode: applicantValues?.state?.phone?.countryCode,
		phone: applicantValues?.state?.phone?.number,
		email: applicantValues?.state?.email,
	};
	return initialValues;
};

export const convertCountriesToFormValues = (countries: Country[]) => {
	const countriesGroupedByCallingCode = new Map<string, string>();

	countries.forEach((country) => {
		const label = `${country.names[getApplicationLanguage()]}`;
		const value = `+${country.callingCodes[0]}`;
		const fullLabel = `(${value}) ${label}`;

		const countryCodeByValue = countriesGroupedByCallingCode.get(value);

		if (countryCodeByValue) {
			countriesGroupedByCallingCode.set(value, `${countryCodeByValue} / ${label}`);
		} else {
			countriesGroupedByCallingCode.set(value, fullLabel);
		}
	});

	return countriesGroupedByCallingCode;
};
